import { Const } from '../lib/const.cls'

export const getters = {
    [Const.GET_PROFILE_INFO]: (state) => { return state.profileInfo },
    [Const.GET_PAYMENT_METHODS]: (state) => { return state.GetPaymentMethods },

    [Const.GET_NOTIFICATION_LIST]: (state) => { return state.notificationList },

    [Const.GET_UNREAD_NOTIFICATION_DATA]: (state) => { return state.notificationUnreadList },
    [Const.GET_NOTIFICATION_ENABLE_GET_SETTINGS]: (state) => { return state.notificationEnablegetSettings },
    [Const.GET_NOTIFICATION_GET_SETTINGS]: (state) => { return state.notificationGetSettings },

    [Const.GET_STATE_REFRESH_DATA]: (state) => { return state.refreshData },
    [Const.GET_CRYPTO_ADDRESSES]: (state) => { return state.cryptoAddresses },
    [Const.GET_BANK_ADDRESSES]: (state) => { return state.bankAddresses },
    [Const.GET_WATCH_LIST]: (state) => { return state.watchListData },
    [Const.GET_NEWS_LIST]: (state) => { return state.newsList },
    [Const.GET_CRYPTO_NEWS_LIST]: (state) => { return state.cryptoNewsList },

}


// WEBPACK FOOTER //
// ./src/plugins/commonAll/provider/store-addons/getters.js